module.exports = __webpack_public_path__ + "img/pick4.4e5e82ba.png";